/**
 * Created by AlexanderC on 6/15/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Log = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepKernel = require('deep-kernel');

var _deepKernel2 = _interopRequireDefault(_deepKernel);

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

var _ConsoleDriver = require('./Driver/ConsoleDriver');

var _RavenDriver = require('./Driver/RavenDriver');

var _RavenBrowserDriver = require('./Driver/RavenBrowserDriver');

var _RumSqsDriver = require('./Driver/RumSqsDriver');

var _AbstractDriver = require('./Driver/AbstractDriver');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Logging manager
 */
let Log = exports.Log = function (_Kernel$ContainerAwar) {
  _inherits(Log, _Kernel$ContainerAwar);

  /**
   * @param {Object} drivers
   */
  function Log() {
    let drivers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Log);

    var _this = _possibleConstructorReturn(this, (Log.__proto__ || Object.getPrototypeOf(Log)).call(this));

    _this._drivers = new _deepCore2.default.Generic.ObjectStorage();

    for (let driverName in drivers) {
      if (!drivers.hasOwnProperty(driverName)) {
        continue;
      }

      _this.register(driverName, drivers[driverName]);
    }
    return _this;
  }

  /**
   * Booting a certain service
   *
   * @param {Kernel} kernel
   * @param {Function} callback
   */


  _createClass(Log, [{
    key: 'boot',
    value: function boot(kernel, callback) {
      let globals = kernel.config.globals;
      let drivers = globals.logDrivers || {};

      // add console driver by default to all environments except for PROD
      if (!drivers.hasOwnProperty('console') && kernel.env !== _deepKernel2.default.PROD_ENVIRONMENT) {
        drivers.console = {};
      }

      for (let driverName in drivers) {
        if (!drivers.hasOwnProperty(driverName)) {
          continue;
        }

        this.register(driverName, drivers[driverName]);
      }

      callback();
    }

    /**
     *
     * @param {String} type
     * @param {Array} args
     * @returns {AbstractDriver}
     */

  }, {
    key: 'create',
    value: function create(type) {
      var driver;

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      switch (type.toLowerCase()) {
        case 'console':
          driver = new (Function.prototype.bind.apply(_ConsoleDriver.ConsoleDriver, [null].concat(args)))();
          break;
        case 'raven':
        case 'sentry':
          let DriverPrototype = this.container.get(_deepKernel2.default.CONTEXT).isFrontend ? _RavenBrowserDriver.RavenBrowserDriver : _RavenDriver.RavenDriver;

          driver = new DriverPrototype(args.length > 0 && typeof args[0] === 'object' ? args[0].dsn : null);
          break;
        case 'rum':
          let rumQueueUrl = this.kernel.config.hasOwnProperty('rumQueue') ? this.kernel.config.rumQueue.url : '';
          let enabled = args.length > 0 && args[0] && typeof args[0] === 'object' ? args[0].enabled : false;

          driver = new _RumSqsDriver.RumSqsDriver(rumQueueUrl, this.kernel, enabled);
          break;
        default:
          throw new _deepCore2.default.Exception.InvalidArgumentException(type, '[Console, Raven, Sentry, RUM]');
      }

      return driver;
    }

    /**
     * @param {*} args
     * @returns {Log}
     *
     * @todo: do we need this here?
     */

  }, {
    key: 'overrideJsConsole',
    value: function overrideJsConsole() {
      var _ref;

      let consoleDriver = this._drivers.find(_ConsoleDriver.ConsoleDriver);

      if (!consoleDriver) {
        this.register('console');
      }

      (_ref = consoleDriver || this._drivers.find(_ConsoleDriver.ConsoleDriver)).overrideNative.apply(_ref, arguments);

      return this;
    }

    /**
     * @param {AbstractDriver|String} driver
     * @param {Array} args
     * @returns {Log}
     */

  }, {
    key: 'register',
    value: function register(driver) {
      if (typeof driver === 'string') {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        driver = this.create.apply(this, [driver].concat(args));
      }

      if (!(driver instanceof _AbstractDriver.AbstractDriver)) {
        throw new _deepCore2.default.Exception.InvalidArgumentException(driver, 'AbstractDriver');
      }

      this._drivers.add(driver);

      return this;
    }

    /**
     * @returns {Core.Generic.ObjectStorage}
     */

  }, {
    key: 'log',


    /**
     * @param {String} msg
     * @param {String} level
     * @param {Object} context
     * @returns {Log}
     */
    value: function log(msg) {
      let level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Log.INFO;
      let context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      let driversArr = this.drivers.iterator;

      for (let driverKey in driversArr) {
        if (!driversArr.hasOwnProperty(driverKey)) {
          continue;
        }

        let driver = driversArr[driverKey];

        // do not log common messages into RUM
        if (driver instanceof _RumSqsDriver.RumSqsDriver) {
          continue;
        }

        driver.log(msg, level, context);
      }

      return this;
    }

    /**
     * @returns {Boolean}
     */

  }, {
    key: 'isRumEnabled',
    value: function isRumEnabled() {
      let driver = this.rumDriver();

      return driver && driver.enabled;
    }

    /**
     * @param {Object} event
     */

  }, {
    key: 'rumLog',
    value: function rumLog(event) {
      let driver = this.rumDriver();

      if (driver) {
        driver.log(event, (error, data) => {
          if (error) {
            this.log(error, Log.ERROR, event);
          }
        });
      }
    }

    /**
     * Flushes RUM batch messages
     * @param {Function} callback
     */

  }, {
    key: 'rumFlush',
    value: function rumFlush(callback) {
      let driver = this.rumDriver();

      if (!driver) {
        callback(null, null);
        return;
      }

      driver.flush((error, data) => {
        if (error) {
          this.log(error, Log.ERROR);
        }

        callback(error, data);
      });
    }

    /**
     * @returns {RumSqsDriver}
     */

  }, {
    key: 'rumDriver',
    value: function rumDriver() {
      return this.drivers.find(_RumSqsDriver.RumSqsDriver);
    }

    /**
     * @param {String} msg
     * @param {Object} context
     * @returns {Log}
     */

  }, {
    key: 'debug',
    value: function debug(msg) {
      let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.log(msg, Log.DEBUG, context);
    }

    /**
     * @param {String} msg
     * @param {Object} context
     * @returns {Log}
     */

  }, {
    key: 'err',
    value: function err(msg) {
      let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.log(msg, Log.ERROR, context);
    }

    /**
     * @param {Array} args
     * @returns {Object}
     */

  }, {
    key: 'error',
    value: function error() {
      return this.err.apply(this, arguments);
    }

    /**
     * @param {String} msg
     * @param {Object} context
     * @returns {Log}
     */

  }, {
    key: 'info',
    value: function info(msg) {
      let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.log(msg, Log.INFO, context);
    }

    /**
     * @param {String} msg
     * @param {Object} context
     * @returns {Log}
     */

  }, {
    key: 'warn',
    value: function warn(msg) {
      let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.log(msg, Log.WARNING, context);
    }

    /**
     * @param {*} args
     * @returns {*}
     */

  }, {
    key: 'warning',
    value: function warning() {
      return this.warn.apply(this, arguments);
    }

    /**
     * @param {String} msg
     * @param {Object} context
     * @returns {Log}
     */

  }, {
    key: 'emerg',
    value: function emerg(msg) {
      let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.log(msg, Log.EMERGENCY, context);
    }

    /**
     * @param {*} args
     * @returns {*}
     */

  }, {
    key: 'emergency',
    value: function emergency() {
      return this.emerg.apply(this, arguments);
    }

    /**
     * @param {String} msg
     * @param {Object} context
     * @returns {Log}
     */

  }, {
    key: 'crit',
    value: function crit(msg) {
      let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.log(msg, Log.CRITICAL, context);
    }

    /**
     * @param {*} args
     * @returns {*}
     */

  }, {
    key: 'critical',
    value: function critical() {
      return this.crit.apply(this, arguments);
    }

    /**
     * @param {String} msg
     * @param {Object} context
     * @returns {Log}
     */

  }, {
    key: 'notice',
    value: function notice(msg) {
      let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.log(msg, Log.NOTICE, context);
    }

    /**
     * @param {String} msg
     * @param {Object} context
     * @returns {Log}
     */

  }, {
    key: 'alert',
    value: function alert(msg) {
      let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.log(msg, Log.ALERT, context);
    }

    /**
     * @returns {Array}
     */

  }, {
    key: 'drivers',
    get: function get() {
      return this._drivers;
    }
  }], [{
    key: 'LEVELS',
    get: function get() {
      return [Log.EMERGENCY, Log.ALERT, Log.CRITICAL, Log.ERROR, Log.WARNING, Log.NOTICE, Log.INFO, Log.DEBUG];
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'EMERGENCY',
    get: function get() {
      return 'emergency';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'ALERT',
    get: function get() {
      return 'alert';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'CRITICAL',
    get: function get() {
      return 'critical';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'ERROR',
    get: function get() {
      return 'error';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'WARNING',
    get: function get() {
      return 'warning';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'NOTICE',
    get: function get() {
      return 'notice';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'INFO',
    get: function get() {
      return 'info';
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'DEBUG',
    get: function get() {
      return 'debug';
    }
  }]);

  return Log;
}(_deepKernel2.default.ContainerAware);


//////////////////
// WEBPACK FOOTER
// ../~/deep-log/lib.compiled/Log.js
// module id = 67
// module chunks = 0